module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/big/1-d84f111e3c1ab6412db5bebcd505e426.webp";